import React, { useEffect, useState } from "react";
import { formatPrice } from "../../utils/formatPrice";
import { useNavigate } from "react-router-dom";
import Header from "../../components/header/Header";
import ProgressBar from "../../components/progressBar/ProgressBar";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../redux/actions/CartActions";
import pricing from "../../assets/data/pricing.json";
import { updateBusinessRequest } from "../../redux/actions/RequestActions";
import serviceCode from "../../assets/data/serviceCode.json";
import { addToServiceList } from "../../redux/actions/ServiceListActions";
import Swal from "sweetalert2";
import Loader from "../../components/loader/Loader";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaCheck, FaTimes } from "react-icons/fa";

const nameOptions = [
  {
    label: "Oui",
    value: "yes",
    icon: <FaCheck size={35} color="green" />,
    description: "Vous devrez fournir vous-même le nom de entreprise.",
  },
];

function EditBusinessName() {
  const navigate = useNavigate();
  const currentStep = "Entreprise";
  const steps = [
    "Propriétaire",
    "Entreprise",
    "Services",
    "Paiement",
    "Finalisation",
  ];
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);
  const { user } = useSelector((state) => state.authUser);
  const [submitting, setSubmitting] = useState(false);
  const servicesList = useSelector((state) => state.serviceList.services);
  const { businessCreationRequest } = useSelector((state) => state.request);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleOptionSelect = async (option) => {
    if (option === "yes") {
      await dispatch(
        addToCart({
          haveBusinessName: true,
        }),
      );
      navigate("/have-business-name-2");
    } else {
      setSubmitting(true);

      let updatedServices = [...servicesList];
      updatedServices.push({
        code: serviceCode.businessName,
        billing: "lifetime",
      });

      await dispatch(
        updateBusinessRequest(
          user.token,
          businessCreationRequest.reference,
          {
            services: [...updatedServices],
          },
          handleCallback,
        ),
      );
    }
  };

  const handleCallback = async ({ success, message }) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
    });
    if (success) {
      await dispatch(
        addToCart({
          haveBusinessName: false,
          businessName: {
            amount: pricing.businessName,
          },
        }),
      );

      await dispatch(
        addToServiceList({
          code: serviceCode.businessName,
          billing: "lifetime",
        }),
      );

      navigate(-1, { replace: true });
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
    }
    setSubmitting(false);
  };

  return (
    <div style={{ backgroundColor: "#fff", paddingBottom: "40px" }}>
      <Header />
      <Loader isLoading={submitting} />
      <ProgressBar steps={steps} currentStep={currentStep} />

      <>
        {/* Title Section */}
        <div className="container mt-4 mb-5 text-center">
          <h4 className="text-2xl font-semibold">
            Avez-vous déjà un <span style={{ color: "#FF5500" }}>nom</span> pour
            votre {cart?.businessType} ?
          </h4>
        </div>

        {/* Option Selection Boxes */}
        <div className="container mt-3 d-flex justify-content-center">
          <div className="row w-100" style={{ maxWidth: "600px" }}>
            {nameOptions.map((option, index) => (
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip id={`tooltip-${index}`}>
                    {option.description}
                  </Tooltip>
                }
              >
                <div className="col-6 mb-4" key={index}>
                  <div
                    className="option-box d-flex align-items-center justify-content-center flex-column"
                    onClick={() => handleOptionSelect(option.value)}
                    style={{
                      height: "200px",
                      border: "2px solid #ddd",
                      borderRadius: "8px",
                      padding: "20px",
                      cursor: "pointer",
                      transition: "border-color 0.3s",
                      textAlign: "center",
                      color: "#000",
                      position: "relative",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.borderColor = "#FF5500")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.borderColor = "#ddd")
                    }
                  >
                    {option.icon}

                    <span style={{ fontSize: "1.1rem", fontWeight: "bold" }}>
                      {option.label}
                    </span>

                    {option.label === "Non" && (
                      <div
                        style={{
                          marginTop: "10px",
                          fontSize: "0.9rem",
                          textAlign: "center",
                        }}
                      >
                        <span>Je le confie à Platform98</span>
                        <br />
                        <span style={{ color: "#FF5500" }}>
                          ({formatPrice(50000)})
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </OverlayTrigger>
            ))}
          </div>
        </div>
      </>
    </div>
  );
}

export default EditBusinessName;
